module.exports = __webpack_public_path__ + "img/error.f8a3af20.png";